import { useState } from "react";
// import { useNavigate } from "react-router";
import TransparencyScore from "./TransparencyScore";
import AttributePage from "./Attribute";
import Packaging from "./Packaging";
import AnimalWelfare from "./AnimalWelfare";
import ClimateChange from "./ClimateChange";
import RiskStatusThreshold from "./RiskThreshold/RiskStatusThreshold";
// import Archive from "./Archive/ArchiveDefault";
import BreadCrumbs from "./BreadCrumbs";
import { COLUMNTITLES } from "@/utils/Enum";
import AdminTabs from "../../interfaces/AdminTabs";
import Dialog from "../../components/Dialog/Dialog";

const styles = {
  tabButton: (isActive: boolean, isDisabled: boolean) =>
    `bg-none border-none mt-[8px] inline-flex px-4 py-2 rounded-t-lg whitespace-nowrap transition-colors duration-200 ${isActive ? "bg-white cursor-pointer" : "bg-gray-400"
    } ${isDisabled && "bg-gray-400/25 text-opacity-50 cursor-default"}
    h-[40px] text-[14px] font-medium leading-normal`,
  archiveButton:
    "float-right mr-[20px] mb-[16px] px-[16px] py-[6px] rounded-sm border-2 border-blue text-blue whitespace-nowrap text-[14px] font-medium leading-normal",
};

const adminTabs: AdminTabs[] = [
  {
    label: COLUMNTITLES.OVERALL,
    content: <AttributePage category="overall" />,
  },
  {
    label: COLUMNTITLES.TRANSPARENCY,
    content: <TransparencyScore />,
  },
  {
    label: COLUMNTITLES.ENVIRONMENT,
    content: <AttributePage category="environmental" />,
  },
  {
    label: COLUMNTITLES.HUMANRIGHTS,
    content: <AttributePage category="humanrights" />,
  },
  {
    label: COLUMNTITLES.RISK_STATUS_THRESHOLD,
    content: <RiskStatusThreshold />,
    disabled: false,
  },
  {
    label: COLUMNTITLES.PACKAGING,
    content: <Packaging />,
    disabled: true,
  },
  {
    label: COLUMNTITLES.ANIMALWELFARE,
    content: <AnimalWelfare />,
    disabled: true,
  },
  {
    label: COLUMNTITLES.CLIMATECHANGE,
    content: <ClimateChange />,
    disabled: true,
  },
];

// const archiveTab = { label: COLUMNTITLES.VIEWARCHIVE, content: <Archive /> };

const AdminDefaultLayout = ({ className }: { className?: string }) => {
  const [activeTab, setActiveTab] = useState(0);
  // const navigate = useNavigate();
  // const handleArchiveClick = () => {
  //   navigate("./archive");
  // };
  const handleTabClick = (index: number, disabled?: boolean) => {
    if (!disabled) setActiveTab(index);
  };

  /* Begin of dialog box testing */
  // Please remove this area when the testing is completed
  const [showDialog, setShowDialog] = useState(false);

  const controlDialog = () => {
    setShowDialog(true);
  };
  /* End of the dialog box testing */

  return (
    <div className={`flex flex-col min-h-screen ${className}`}>
      {showDialog && (
        <Dialog
          center
          onClose={() => {
            setShowDialog(false);
          }}
        />
      )}
      <div className="bg-gray-200">
        <div className="py-4 pb-10">
          <BreadCrumbs />
        </div>

        <div className="flex justify-between">
          <div className="flex mt-1 ml-10">
            {adminTabs.map((tab, index) => (
              <button
                key={index}
                id={tab.label}
                className={styles.tabButton(
                  activeTab === index,
                  !!tab.disabled,
                )}
                onClick={() => handleTabClick(index, tab.disabled)}
              >
                {tab.label}
              </button>
            ))}
          </div>
          {/* Uncomment to enable the archive tab */}
          {/* <button
            id={archiveTab.label}
            className={styles.archiveButton}
            onClick={handleArchiveClick}
          >
            {archiveTab.label}
          </button> */}
        </div>
      </div>

      <div className="bg-white grow-5" id={adminTabs[activeTab].label}>
        {adminTabs[activeTab].content}
      </div>
      {/* The following block is for the dialog box testing */}
      <div className="relative">
        <button
          className="absolute right-6 bottom-6 text-4xl text-gray-400"
          onClick={controlDialog}
        >
          *
        </button>
      </div>
      {/* The end for the dialog box testing */}
    </div>
  );
};

export default AdminDefaultLayout;
